module.exports = __webpack_public_path__ + "images/assets/d44454b430f37f24dc9a33307989a41c.svg";